// 用于参数

export const LoadParams = Vue => {
    const _CPLB_ = {
        huace: -1,
        //精装
        huacejz: 204,
        //uv画册精装
        uvhuacejz: 205,

        //数码画册精装
        smhcjz: 210,

        danye: 1,
        waleng: 2,
        dalibao: 3,
        duilian: 4,
        fuzi: 5,
        guali: 6,
        taili: 7,
        mingpian: 8,
        //数码名片
        mingpianshuma: 208,
        caihe: 9,
        dangandai: 10,
        dangandaishuma: 212, // 数码档案袋
        diaopai: 11,
        xinfeng: 12,
        baozhi: 13,
        xinzhi: 14,
        xinzhishuma: 141,
        fengtao: 15,
        fengtaoshuma: 211, // 数码封套
        buganjiao: 16,
        shoutidai: 17,
        shoutidaishuma: 209,
        qimading: 18,
        wuxianjiaozhuang: 19,
        purjiaozhuang: 1901,
        purjingzhuang: 2006,
        suoxianjiaozhuang: 20,
        luobeizhuang: 2001,
        xianquanhuanzhuang: 2002,
        suoxianjingzhuang: 2003,

        hudieduibiao: 2004,
        tiehuanjingzhuang: 2005,
        pvc: 22,
        wutanliandan: 23,
        //增加其他品类
        hbdanye: 101, //合版单页
        tzmp: 102, //特种名片
        hbxf: 103, //合版信封
        ggzb: 104, //广告纸杯
        kzt: 105, //筷子套
        fkt: 106, //房卡套
        smdy: 107, //数码单页
        smhc: 108, //数码画册
        smbgj: 109, //数码不干胶
        hbbgj: 110, //合版不干胶
        zbbgj: 111, //专版不干胶
        jbbgj: 112, //卷标不干胶
        nbbgj: 1120, //宁波不干胶 定制
        newsmbgj: 119, //数码不干胶 新加的 wy  20230318
        phtf: 113, //喷绘条幅
        ggk: 114, //刮刮卡
        wfbd: 115, //无纺布
        npjd: 116, //牛皮脚垫
        ggs: 117, //广告扇子
        xsdd: 201, //销售订单,
        uvdanye: 202, //UV单页
        uvhuace: 203, //UV画册

        gualishuma: 601, //数码挂历
        tailishuma: 701 //数码台历
    };
    // 产品类别编码
    Vue.prototype.$cplb = _CPLB_;
    // 订单类别
    Vue.prototype.$o_cplb = [
        { value: _CPLB_.smdy, label: "数码单页" },
        { value: _CPLB_.huacejz, label: "精装画册" },
        { value: _CPLB_.uvhuacejz, label: "uv画册精装" },
        { value: _CPLB_.smhcjz, label: "数码画册精装" },
        { value: _CPLB_.uvdanye, label: "UV单页" },
        { value: _CPLB_.uvhuace, label: "UV画册" },
        { value: _CPLB_.xsdd, label: "销售订单" },
        { value: _CPLB_.hbdanye, label: "合版单页" },
        { value: _CPLB_.tzmp, label: "特种名片" },
        { value: _CPLB_.hbxf, label: "合版信封" },
        { value: _CPLB_.ggzb, label: "广告纸杯" },
        { value: _CPLB_.kzt, label: "筷子套" },
        { value: _CPLB_.fkt, label: "房卡套" },
        { value: _CPLB_.smdy, label: "数码单页" },
        { value: _CPLB_.smhc, label: "数码画册" },
        { value: _CPLB_.smbgj, label: "数码不干胶(表格)" },
        { value: _CPLB_.hbbgj, label: "合版不干胶" },
        { value: _CPLB_.zbbgj, label: "专版不干胶" },
        { value: _CPLB_.jbbgj, label: "卷标不干胶" },
        { value: _CPLB_.newsmbgj, label: "数码不干胶" }, //新加的数码不干胶  wy 20230319
        { value: _CPLB_.phtf, label: "喷绘条幅" },
        { value: _CPLB_.ggk, label: "刮刮卡" },
        { value: _CPLB_.wfbd, label: "无纺布" },
        { value: _CPLB_.npjd, label: "牛皮脚垫" },
        { value: _CPLB_.ggs, label: "广告扇子" },


        { value: _CPLB_.danye, label: "单页" },
        { value: _CPLB_.huace, label: "画册" },
        { value: _CPLB_.shoutidai, label: "手提袋" },
        { value: _CPLB_.dangandai, label: "档案袋" },
        { value: _CPLB_.diaopai, label: "吊牌" },
        { value: _CPLB_.duilian, label: "对联" },
        { value: _CPLB_.fengtao, label: "封套" },
        { value: _CPLB_.fuzi, label: "福字" },
        { value: _CPLB_.guali, label: "挂历" },
        { value: _CPLB_.buganjiao, label: "不干胶" },
        { value: _CPLB_.mingpian, label: "名片" },
        { value: _CPLB_.pvc, label: "PVC" },
        { value: _CPLB_.xinfeng, label: "信封" },
        { value: _CPLB_.waleng, label: "小包装" },
        { value: _CPLB_.dalibao, label: "大礼包" },
        { value: _CPLB_.wutanliandan, label: "无碳联单" },
        { value: _CPLB_.caihe, label: "彩盒" },
        { value: _CPLB_.baozhi, label: "报纸" },
        { value: _CPLB_.xinzhi, label: "便签" },
        { value: _CPLB_.xinzhishuma, label: "数码便签" },
        { value: _CPLB_.taili, label: "台历" },


        { value: _CPLB_.mingpianshuma, label: "数码名片" },
        { value: _CPLB_.shoutidaishuma, label: "数码手提袋" },
        { value: _CPLB_.dangandaishuma, label: "数码档案袋" },
        { value: _CPLB_.fengtaoshuma, label: "数码封套" },

        { value: _CPLB_.tailishuma, label: "数码台历" },
        { value: _CPLB_.gualishuma, label: "数码挂历" }
    ];
    Vue.prototype.$cpbjmc = {
        baozhuanglizhi: "包装里纸",
        baozhuangmianzhi: "包装面纸",
        taililizhi: "支架内裱纸",
        tailimianzhi: "支架外裱纸",
        tailineiye: "台历内页",
        gualifengpi: "挂历封皮",
        gualineiye: "挂历内页",
        huacefengpi: "封皮",
        bianqian: "便签",
        bianqianfengpi: "便签封皮",
        shumabianqian: "数码便签",
        shumabianqianfengpi: "数码便签封皮",
        huaceneiye: "内页",
        huacefeiye: "扉页",
        huanchen: "精装环衬",
        jiaceng: "精装夹层",
        mianzhi: "精装面纸"
    };
    Vue.prototype.$BaoJiaFangShi = {
        PingZhangZhi: {
            value: 0,
            label: "平张纸"
        },
        FenQieZhi: {
            value: 1,
            label: "分切纸"
        },
        TeJiaBiao: {
            value: 2,
            label: "特价表"
        },
        DanPin: {
            value: 3,
            label: "单拼"
        },
        ShuangPing: {
            value: 4,
            label: "双拼"
        },
        ShuMaoBaoJia: {
            value: 5,
            label: "数码报价"
        },
        ShuangLiangBan: {
            value: 6,
            label: "双联版"
        },
        YangBenLeiYeHeBingBaoJia: {
            value: 7,
            label: "样本内页合并报价"
        }
    };
    Vue.prototype.$ThemeNames = [{
            name: "默认主题",
            value: "default"
        },
        {
            name: "白色主题",
            value: "theme-white"
        },
        {
            name: "红色主题",
            value: "theme-star"
        },
        {
            name: "蓝色主题",
            value: "theme-hey"
        },
        {
            name: "small主题",
            value: "theme-d2"
        },
        {
            name: "HappyPrint主题",
            value: "theme-iview"
        }
    ];
    Vue.prototype.$BaoJiaFangShis = Object.values(Vue.prototype.$BaoJiaFangShi);
    Vue.prototype.$MChanPinInfo = {
        //是否是合版
        sfheban: false,
        SuFeng: false,
        TaoDai: false,
        ZhuangXiang: false, //装箱
        BuJians: [], // 产品部件集合
        ShuJi: "",
        DuTouBu: "",
        ShowZhiBan: true,
        SiDai: "",

        DanPinGongSiHeight: "",
        DanPinGongSiWidth: "",
        ShuangPinGongSiHeight: "",
        ShuangPinGongSiWidth: "",

        ChanPinFenLei: {
            // 产品分类
            DanZhang: false, // 单张 后面需要添加其余的产品信息
            UVDanZhang: false,
            UVYangBenHuaCe: false,
            HBDanZhang: false,
            XiaoBaoZhuang: false,
            DaLiBao: false,
            DuiLian: false,
            FuZi: false,
            GuaLi: false,
            GuaLiShuMa: false, //数码挂历
            TaiLi: false,
            TaiLiShuMa: false, //数码台历
            MingPian: false,
            CaiHe: false,
            DangAnDai: false,
            ShuMaDangAnDai: false, //数码档案袋
            DiaoPai: false,
            XinFeng: false,
            BaoZhi: false,
            BiaoQian: false,
            ShuMaBiaoQian: false,
            FengTao: false,
            ShuMaFengTao: false, //数码封套
            //彩印不干胶
            BuGanJiao: false,
            //2020-10-09合版不干胶
            HBBuGanJiao: false,
            //专版不干胶
            ZBBuGanJiao: false,
            //宁波特殊不干胶
            NBBuGanJiao: false,
            NewSMBuGanJiao: false,
            ShouTiDai: false,
            YangBenHuaCe: false,

            // QiMaDing: false,
            // WuXianJiaoZhuang: false,
            // SuoXianJiaoZhuang: false,
            // SuoXianJingZhuang: false,
            PVC: false,
            WuTanLianDan: false
        },
        JiaLeiKou: {
            LeiKouKuanDu: 0
        },
        JiaZheDou: {
            ShuangZheDou: false,
            ZheDouGaoDu: 0
        },
        JiaLaYe: {
            ShuangLanYe: true,
            LaYeKuanDu: 0
        },
        ZhuangDingFangShi: "", //骑马钉
        ChengPinWidth: 0, // 成品尺寸x
        ChengPinHeight: 0, // 成品尺寸y
        ChengPinHou: 0, // 成品厚度z
        ZheDouLeiXing: "", //单折兜
        DianBan: false, //是否添加垫板
        DianBanLeiXing: "", //下垫板
        QiQiang: 0, //起墙
        GGGD: 40,
        ZhanKaiWidth: 0, // 展开尺寸
        ZhanKaiHeight: 0, // 展开尺寸
        ShuLiang: 0, // 数量
        PinZhong: 1, // 品种
        MeiBenYeShu: 1, //每本页数
        CaiChengPin: true,
        ShuangDaMianXiangTong: true,
        ShuangCeMianXiangTong: true,
        ChuanHuanBian: "短边", // 穿环边长度 用来判断哪个是穿环边
        ChuanHuanYanSe: "", // 环颜色
        ZhiJiaoHouDu: 0, // 厚度
        ZhiJiaWidth: 0,
        ZhiJiaHeight: 0,
        SheTou: 0,
        XinFengYangShi: "",
        NBBGJ_TYPE: "",
        NBBGJ_GY: []
    };

    Vue.prototype.$MBuJian = {
        MingCheng: "",
        BuJianFenLei: {
            DanZhang: false, // 需要维护其余的
            HBDanZhang: false,
            UVDanZhang: false,
            XiaoBaoZhuang: false,
            LiBaoDuiLian: false,
            LiBaoHengPi: false,
            LiBaoFuZi: false,
            LiBaoHongBao: false,
            LiBao: false,
            DuiLian: false,
            DuiLianHengpi: false,
            DuiLianFuZi: false,
            FuZi: false,
            GuaLiNeiYe: false,
            TaiLiNeiYe: false,
            TaiLiGongYeBan: false,
            TaiLiWaiBiaoZhi: false,
            TailiNeiBiaoZhi: false,
            MingPian: false,
            CaiHe: false,
            DangAnDai: false,
            DiaoPai: false,
            XinFeng: false,
            BaoZhi: false,
            BianQian: false,
            FengTao: false,
            BuGanJiao: false,
            HBBuGanJiao: false, //这里设置没有用，部件都用的不干胶
            //部件里面专版不干胶
            ZBBuGanJiao: false, //这里设置没有用，部件都用的不干胶
            ShouTiDai: false,
            HuaCeFengPi: false,
            HuaCeNeiYe: false,
            HuaCeHuanChen: false,
            HuaCeJiaCeng: false,
            HuaCeFeiYe: false,
            HuaCeLaYe: false,
            HuaCeXunHuanNeiYe: false
        },
        ZhengMianColor: {
            ZhuanSe: 0 // 用于颜色的id，在后台需要修改为正确的MYinShuaColors对象
        },
        FanMianColor: {
            ZhuanSe: 0 // 用于颜色的id，在后台需要修改为正确的MYinShuaColors对象
        },
        ZhiZhang: {
            LeiXing: "", // 用于材料的bjzhizhangleixingid，不干胶时为不干胶材料的名称
            KeZhong: 0 // 用于材料的bjzhizhangid
        },
        Width: {
            Value: 0
        },
        Height: {
            Value: 0
        },
        ZiDaiZhi: false,
        // ZiDingYiShow: false,
        HouGongCanShu: [],
        ShuangDaMianXiangTong: false,
        ShuangCeMianXiangTong: false,
        HouGong: {
            YaHen: {
                YaHenZhe: "",
                Enable: false,
                JiDaoHen: 1
            },
            YiSiXian: {
                // YiSiXian: "易撕线", //应不应该写死? wy  20230718
                JiTiaoXian: 1,
                Enable: false
            },
            DanMianJiTu: {
                Enable: false,
                Width: "",
                Height: "",
                ZhongLei: "击凸"
            },
            DanMianTangJin: [
                // {
                //   Enable: false,
                //   Width: "",
                //   Height: "",
                //   Color: ""
                // }
            ],
            DanMianTangYin: [
                // {
                //   Enable: false,
                //   Width: "",
                //   Height: "",
                //   Color: ""
                // }
            ],
            FuMo: {
                ShuangMianFuMo: "false",
                FuMoZhongLei: "",
                Enable: false
            },
            MoQie: {
                Enable: false,
                MoQieZhongLei: ""
            },
            YaWen: {
                Enable: false,
                ShuangMianYaWen: false
            },
            JuBuUV: {
                Enable: false,
                ShuangMian: "",
                UVCaiLiao: "",
                Width: "",
                Height: ""
            },
            KaiTianChuang: {
                Enable: false,
                Width: "",
                Height: ""
            },
            GuoYou: {
                Enable: false,
                ShuangMianGuoYou: "双面",
                CaiLiao: ""
            },
            DaHaoMa: {
                Enable: false,
                ShuLiang: 1
            },
            ZheYe: {
                Enable: false,
                ZheFa: "",
                canshu: null //折页 长*宽
            },
            DaKong: {
                Enable: false,
                DaKongShuLiang: 1
            },
            DanMianGuaGuaYin: {
                Enable: false
            },
            HuHe: {
                Enable: false,
                HeXing: ""
            },
            ShouTiSheng: {
                Enable: false,
                CaiLiao: "" //2020-03-25 手提绳材料
            },
            TiBa: {
                Enable: false
            },
            DaMaoDing: {
                Enable: false
            },
            JiaoTou: {
                Enable: false
            },
            DaPingDing: {
                Enable: false,
                ShuLiang: 2
            },
            QuanBaoPi: {
                Enable: false
            },
            BanBaoPi: {
                Enable: false,
                Width: 20
            },
            XiaoBaoZhuang: {
                CaiLiao: "",
                Enable: false
            }
        },
        P: 1,
        PShow: 1,
        PinZhong: 1,
        ShuLiang: 0,
        ZhengFangMianNeiRongXiangTong2: false,
        ZhengFangMianNeiRongXiangTong3: false,
        ZhengFangMianNeiRongXiangTong4: false,
        ZhengFangMianNeiRongXiangTong5: false,
        ZhengFangMianNeiRongBuTong: false,
        JieDiaoKou: false,
        SFYinShua: false,
        SFXiangTong: false,
        SFBuTong: false,
        SFLianYin: false
    };

    Vue.prototype.$FanBanFangShis = [
        { value: 4, label: "正背版" },
        { value: 2, label: "自翻版(不同)" },
        { value: 1, label: "单面" },
        { value: 8, label: "不干胶" },
        { value: 16, label: "自翻版" }
    ];
    Vue.prototype.$ShouKuanFangShi = {
        //支付方式
        yue: -6,
        shouyinbao: -7,
        yinlian: -12,
        shouxin: -8
    };
};


// WEBPACK FOOTER //
// ./src/main-params.js